import React from "react";
import { InitialAuditionStateType } from "../../../../assets/data/initialState";
import { FormikType } from "../../../../types/types";
import { useIASelector } from "../../../../redux/hooks";
import { selectedPerformerTypeFiltersSelector } from "../../../../redux/slices/performerTypeFiltersSlice";
import CustomModal from "../../CustomModal";
import { Dialog } from "@headlessui/react";
import ModalHeader from "../../headers/ModalHeader";
import CustomButton from "../../buttons/CustomButton";
import PerformerTypeFilterModalPerformerTypeFilters from "./PerformerTypeFilterModalPerformerTypeFilters";
import PerformerTypeFilterModalSelectedTypeFilters from "./PerformerTypeFilterModalSelectedTypeFilters";
import PerformerTypeFilterModalEdit from "./PerformerTypeFilterModalEdit";

type Props = FormikType<InitialAuditionStateType> & {
  isOpen: boolean;
  closeModal: () => void;
};

export default function PerformerTypeFilterModal({
  closeModal,
  formik,
  isOpen,
}: Props) {
  const selectedPerformerTypeFilters = useIASelector(
    selectedPerformerTypeFiltersSelector
  );

  const handleSetPerformerTypeFilters = () => {
    formik.setFieldValue("performerTypeFilters", selectedPerformerTypeFilters);
    closeModal();
  };

  return (
    <CustomModal isOpen={isOpen} closeModal={closeModal}>
      <Dialog.Panel className="relative bg-white rounded-lg w-1/2">
        <ModalHeader
          title="Performer Type"
          description="Edit, add and manage this Audition’s Performer Type."
          closeModal={closeModal}
        />
        <div className="grid grid-cols-modal px-4 h-full">
          <div className="h-4/5 w-full justify-between flex flex-col">
            <div className="w-full grid grid-cols-auditionType">
              <PerformerTypeFilterModalPerformerTypeFilters formik={formik} />
              <PerformerTypeFilterModalSelectedTypeFilters formik={formik} />
            </div>
            <div className="flex-row flex items-center justify-start my-4">
              <CustomButton
                className="medium-black-button mr-2"
                text="Set Performer Types"
                onClick={() => handleSetPerformerTypeFilters()}
              />
              <CustomButton
                className="medium-white-button"
                text="Cancel"
                onClick={closeModal}
              />
            </div>
          </div>
          <PerformerTypeFilterModalEdit formik={formik} />
        </div>
      </Dialog.Panel>
    </CustomModal>
  );
}
